module.exports = __webpack_public_path__ + "static/media/correo.35d24b99.svg";